import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const xpApi = createApi({
  reducerPath: 'xpApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['XP'],
  endpoints: (builder) => ({
    getMyXP: builder.query({
      query: () => '/users/me/xp',
      providesTags: ['XP'],
    }),
    getPublicXP: builder.query({
      query: (userId) => `/users/${userId}/xp`,
    }),
    dailyLogin: builder.mutation({
      query: () => ({ url: '/xp/daily-login', method: 'POST' }),
      invalidatesTags: ['XP'],
    }),
  }),
});

export const { useGetMyXPQuery, useGetPublicXPQuery, useDailyLoginMutation } = xpApi;
